/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
async function n(n,r){try{return await n}catch(t){if("no-queryEngine"!==t.name)throw t;return r}}export{n as handleNoEngineError};
